import { View, Text } from "@react-pdf/renderer";

import { styles } from "../styles";

export function AdditionalInformation() {
  return (
    <View
      style={{
        display: "flex",
        flexDirection: "column",
        marginTop: 5,
      }}
    >
      <Text style={{ ...styles.bodyText, fontFamily: "Helvetica-Bold" }}>
        Additional Information
      </Text>
      <Text style={{ ...styles.bodyText }}>
        This notice gives our opinion, not an official insurance decision.
        Signing below signifies that you have received and understand this
        notice.
      </Text>
    </View>
  );
}
